<template>
    <v-footer v-if="footerBlock" class="px-2 main-foot">
        <v-container :class="$breakpoint.xsOnly ? 'margin-17' : ''">
            <v-row>
                <v-col cols="12" md="3" sm="12">
                    <v-img
                        :src="`${CDN_IMG_URL}/website-logo.webp`"
                        :lazy-src="`${CDN_IMG_URL}/website-logo.webp`"
                        :width="$breakpoint.xsOnly ? 80 : 130"
                        class="pre_logo"
                        contain
                        :aspect-ratio="
                            $vuetify.breakpoint.smAndDown ? 1.5 : 1.67
                        "
                        alt="Logo"
                    ></v-img>
                    <div class="caption-foot">
                        <span v-if="setUp === 'bd'">
                            Established in 2020, Play Ventures NV is the most
                            trusted betting exchange and leading online casino.
                        </span>
                        <span
                            v-else-if="domainType && domainType == 'SuperWin'"
                        >
                            {{ $t("footer.copyrightSuperwin") }}
                        </span>
                        <span v-else>
                            {{ $t("footer.copyright") }}
                        </span>
                    </div>
                    <!-- <v-col
                        v-if="
                            getWhatsappData &&
                            getWhatsappData.isWhatsAppNo &&
                            getWhatsappData.number
                        "
                        class="pl-0"
                        cols="6"
                        md="12"
                        sm="3"
                    >
                        <v-divider></v-divider>
                    </v-col> -->
                    <!-- <div>
            Contact us:
            <a
              :href="`https://api.whatsapp.com/send?phone=${+12494880891}`"
              target="_blank"
              rel="noreferrer noopener"
              class="text-decoration-none"
              :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
              >+12494880891
            </a>
          </div> -->
                    <!-- <div
                        v-if="
                            getWhatsappData &&
                            getWhatsappData.isWhatsAppNo &&
                            getWhatsappData.number &&
                            getWhatsappData.whatsAppLink
                        "
                    >
                        {{ $t("footer.contact_us") }}:
                        <a
                            :href="getWhatsappData.whatsAppLink"
                            target="_blank"
                            rel="noreferrer noopener"
                            class="text-decoration-none"
                            :class="
                                $vuetify.theme.dark
                                    ? 'white--text'
                                    : 'black--text'
                            "
                            >{{ getWhatsappData.number }}
                        </a>
                        :href="`https://api.whatsapp.com/send?phone=${getWhatsappData.number}`"
                    </div> -->
                </v-col>

                <v-col cols="12" sm="12" md="12" class="hidden-md-and-up">
                    <v-divider></v-divider>
                </v-col>

                <v-col v-if="setUp !== 'fps'" cols="6" sm="3" md="2">
                    <div
                        class="text-md-h6 text-h7 text-uppercase font-weight-bold mb-2"
                    >
                        {{ $t("footer.game") }}
                    </div>
                    <ul class="pl-0 caption list-style-none">
                        <li
                            v-for="item in getListOne()"
                            :key="item.name"
                            class="text-capitalize mb-2"
                        >
                            {{ item.domainTypeAbc }}
                            <a
                                v-if="liveList"
                                hreflang="en"
                                :href="item.link"
                                class="text-decoration-none"
                                :class="
                                    $vuetify.theme.dark
                                        ? 'white--text'
                                        : 'black--text'
                                "
                            >
                                {{ $t(item.name) }}
                            </a>
                            <a
                                v-else-if="item.name !== 'Live Cards'"
                                hreflang="en"
                                :href="item.link"
                                class="text-decoration-none"
                                :class="
                                    $vuetify.theme.dark
                                        ? 'white--text'
                                        : 'black--text'
                                "
                            >
                                {{ $t(item.name) }}
                            </a>
                            <span v-if="item.name == 'Live Cards' && liveList">
                                <button
                                    class="live-cards-button"
                                    @click="handleShowHideLiveCards(item.name)"
                                >
                                    <v-icon v-if="showLiveCardList" size="14"
                                        >mdi-chevron-up</v-icon
                                    >
                                    <v-icon v-else size="14"
                                        >mdi-chevron-down</v-icon
                                    >
                                </button>
                                <ul
                                    :class="
                                        showLiveCardList
                                            ? 'list-display'
                                            : 'list-hide'
                                    "
                                >
                                    <li
                                        v-for="game in liveCardGames"
                                        :key="game.name"
                                        class="live-cards-list"
                                    >
                                        <a
                                            hreflang="en"
                                            :href="game.link"
                                            class="text-decoration-none"
                                            :class="
                                                $vuetify.theme.dark
                                                    ? 'white--text'
                                                    : 'black--text'
                                            "
                                        >
                                            {{ $t(game.name) }}
                                        </a>
                                    </li>
                                </ul>
                            </span>
                            <span v-if="item.name == 'Satta Matka' && liveList">
                                <button
                                    class="live-cards-button"
                                    @click="handleShowHideLiveCards(item.name)"
                                >
                                    <v-icon v-if="showMatkaList" size="14"
                                        >mdi-chevron-up</v-icon
                                    >
                                    <v-icon v-else size="14"
                                        >mdi-chevron-down</v-icon
                                    >
                                </button>
                                <ul
                                    :class="
                                        showMatkaList
                                            ? 'list-display'
                                            : 'list-hide'
                                    "
                                >
                                    <li
                                        v-for="game in listMatkaGame"
                                        :key="game.name"
                                        class="live-cards-list"
                                    >
                                        <a
                                            hreflang="en"
                                            :href="game.link"
                                            class="text-decoration-none"
                                            :class="
                                                $vuetify.theme.dark
                                                    ? 'white--text'
                                                    : 'black--text'
                                            "
                                        >
                                            {{ $t(game.name) }}
                                        </a>
                                    </li>
                                </ul>
                            </span>
                            <span
                                v-if="item.name == 'Online Betting' && liveList"
                            >
                                <button
                                    class="live-cards-button"
                                    @click="handleShowHideLiveCards(item.name)"
                                >
                                    <v-icon
                                        v-if="showOnlineBettingList"
                                        size="14"
                                        >mdi-chevron-up</v-icon
                                    >
                                    <v-icon v-else size="14"
                                        >mdi-chevron-down</v-icon
                                    >
                                </button>
                                <ul
                                    :class="
                                        showOnlineBettingList
                                            ? 'list-display'
                                            : 'list-hide'
                                    "
                                >
                                    <li
                                        v-for="game in listSportsGame"
                                        :key="game.name"
                                        class="live-cards-list"
                                    >
                                        <a
                                            hreflang="en"
                                            :href="game.link"
                                            class="text-decoration-none"
                                            :class="
                                                $vuetify.theme.dark
                                                    ? 'white--text'
                                                    : 'black--text'
                                            "
                                        >
                                            {{ $t(game.name) }}
                                        </a>
                                    </li>
                                </ul>
                            </span>
                            <span v-if="item.name == 'Esports' && liveList">
                                <button
                                    class="live-cards-button"
                                    @click="handleShowHideLiveCards(item.name)"
                                >
                                    <v-icon v-if="showEsportsList" size="14"
                                        >mdi-chevron-up</v-icon
                                    >
                                    <v-icon v-else size="14"
                                        >mdi-chevron-down</v-icon
                                    >
                                </button>
                                <ul
                                    :class="
                                        showEsportsList
                                            ? 'list-display'
                                            : 'list-hide'
                                    "
                                >
                                    <li
                                        v-for="game in listesportsGame"
                                        :key="game.name"
                                        class="live-cards-list"
                                    >
                                        <a
                                            hreflang="en"
                                            :href="game.link"
                                            class="text-decoration-none"
                                            :class="
                                                $vuetify.theme.dark
                                                    ? 'white--text'
                                                    : 'black--text'
                                            "
                                        >
                                            {{ $t(game.name) }}
                                        </a>
                                    </li>
                                </ul>
                            </span>
                        </li>
                    </ul>
                </v-col>

                <v-col cols="6" sm="3" md="2">
                    <div
                        class="text-md-h6 text-h7 text-uppercase font-weight-bold mb-2"
                    >
                        {{ $t("footer.company") }}
                    </div>
                    <ul class="pl-0 caption list-style-none">
                        <li
                            v-for="item in listTwo"
                            :key="item.name"
                            class="text-capitalize mb-2"
                        >
                            <a
                                v-if="item.name !== 'AML Policies'"
                                hreflang="en"
                                :href="item.link"
                                class="text-decoration-none"
                                :class="
                                    $vuetify.theme.dark
                                        ? 'white--text'
                                        : 'black--text'
                                "
                            >
                                {{ $t(item.name) }}
                            </a>
                        </li>
                    </ul>
                </v-col>

                <v-col cols="6" sm="4" md="2">
                    <div
                        class="text-md-h6 text-h7 text-uppercase font-weight-bold mb-2"
                    >
                        {{ $t("footer.resources") }}
                    </div>
                    <ul class="pl-0 caption list-style-none">
                        <li v-if="setUp === 'gb'" class="mb-2">
                            <a
                                href="/blog"
                                rel="noreferrer noopener"
                                class="text-decoration-none"
                                :class="
                                    $vuetify.theme.dark
                                        ? 'white--text'
                                        : 'black--text'
                                "
                            >
                                {{ $t("header.blogs") }}</a
                            >
                        </li>
                        <li
                            v-for="item in listThree"
                            v-show="
                                !item.hide &&
                                (!item.disable ||
                                    (item.disable && item.disable !== setUp))
                            "
                            :key="item.name"
                            class="text-capitalize mb-2"
                        >
                            <a
                                hreflang="en"
                                :href="item.link"
                                class="text-decoration-none"
                                :class="
                                    $vuetify.theme.dark
                                        ? 'white--text'
                                        : 'black--text'
                                "
                            >
                                {{ $t(item.name) }}
                            </a>
                        </li>
                    </ul>
                    <!-- <ul class="pl-0 caption list-style-none">
            <li class="mb-2">
              For Blogs, visit
              <a
                href="https://blog.fairplayclub.com/"
                target="_blank"
                rel="noreferrer noopener"
                >blog.fairplayclub.com</a
              >
            </li>
            <li class="mb-2">
              For Sports News, visit
              <a
                href="https://fairplay-news.co/"
                target="_blank"
                rel="noreferrer noopener"
                >fairplaynews.club</a
              >
            </li>
          </ul> -->
                </v-col>
                <v-col
                    :class="
                        setUp !== 'fps'
                            ? 'col-6 col-sm-2 col-md-1'
                            : 'col-6 col-sm-2 col-md-2'
                    "
                >
                    <div
                        class="text-md-h6 text-h7 text-uppercase font-weight-bold mb-2"
                    >
                        &nbsp;
                    </div>
                    <ul class="pl-0 caption list-style-none">
                        <li
                            v-for="item in listFour"
                            :key="item.name"
                            class="text-capitalize mb-2"
                        >
                            <a
                                hreflang="en"
                                :href="item.link"
                                class="text-decoration-none"
                                :class="
                                    $vuetify.theme.dark
                                        ? 'white--text'
                                        : 'black--text'
                                "
                            >
                                {{ $t(item.name) }}
                            </a>
                        </li>
                    </ul>
                </v-col>
                <v-col
                    class="text-left pt-2"
                    :class="
                        setUp !== 'fps'
                            ? 'col-12 col-sm-12 col-md-2'
                            : 'col-12 col-sm-12 col-md-3'
                    "
                >
                    <div
                        class="text-h6 text-uppercase font-weight-bold mb-2 hidden-sm-and-down"
                    >
                        &nbsp;
                    </div>
                    <social-media
                        class="text-left"
                        size="36"
                        icon-class="mr-2 mt-2 mb-md-2"
                    />
                </v-col>

                <!-- <v-col cols="6" sm="3" md="3">
          <ul class="pl-0 caption list-style-none">
            <li v-if="getWhatsappData && getWhatsappData.number" class="mb-2">
              Contact us:
              <a
                :href="`https://api.whatsapp.com/send?phone=${getWhatsappData.number}`"
                target="_blank"
                rel="noreferrer noopener"
                >{{ getWhatsappData.number }}
              </a>
            </li>
            <li>
              <social-media
                :size="$breakpoint.smAndDown ? 18 : 26"
                :icon-class="$breakpoint.smAndDown ? '' : 'mr-2'"
                class="footer-icon"
              />
            </li>
            <li>
              <v-img
                contain
                :src="`${CDN_IMG_URL}/gc.png`"
                :lazy-src="`${CDN_IMG_URL}/gc.png`"
                aspect-ratio="2"
                max-height="60"
                max-width="120"
                class="text-center white"
                alt="gaming curacao logo"
              ></v-img>
            </li>
          </ul>
        </v-col> -->
                <v-col cols="12" sm="12" md="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col
                    v-if="setUp !== 'bd'"
                    cols="7"
                    sm="3"
                    md="2"
                    class="caption"
                    :class="$breakpoint.smAndDown ? '' : 'gaming-image'"
                >
                    <div class="text-left">
                        <v-img
                            contain
                            :src="`${CDN_IMG_URL}/gc.png`"
                            :lazy-src="`${CDN_IMG_URL}/gc.png`"
                            aspect-ratio="2"
                            height="50"
                            width="150"
                            class="text-center white mb-2"
                            alt="gaming curacao logo"
                        ></v-img>
                    </div>
                    <!-- <div
            v-if="
              getWhatsappData &&
              getWhatsappData.isWhatsAppNo &&
              getWhatsappData.number
            "
          >
            Contact us:
            <a
              :href="`https://api.whatsapp.com/send?phone=${getWhatsappData.number}`"
              target="_blank"
              rel="noreferrer noopener"
              >{{ getWhatsappData.number }}
            </a>
          </div> -->
                </v-col>
                <v-col
                    cols="5"
                    :sm="setUp === 'bd' ? 12 : 3"
                    :md="setUp === 'bd' ? 12 : 10"
                    class="text-sm-left text-md-left text-left d-flex align-center"
                >
                    <div v-if="$breakpoint.mdAndUp">
                        <div class="caption">
                            {{ $t("footer.disclaimer") }} :
                        </div>
                        <div class="caption">
                            {{ $t("footer.disclaimer_text") }}
                        </div>
                    </div>
                    <div v-else class="text-left mr-3">
                        <!-- <v-tooltip top color="primary" class="footer_tooltip">
                            <template #activator="{ on, attrs }">
                                <v-btn
                                    target="_blank"
                                    small
                                    fab
                                    color="primary font-weight-black"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    18+
                                </v-btn>
                            </template>
                            <span
                                ><div class="caption">
                                    {{ $t("footer.disclaimer") }} :
                                </div>
                                <div class="caption">
                                    {{ $t("footer.disclaimer_text") }}
                                </div>
                            </span>
                        </v-tooltip> -->
                        <div class="footer_tooltip">
                            <v-btn
                                target="_blank"
                                small
                                fab
                                color="primary font-weight-black"
                                v-bind="attrs"
                                v-on="on"
                            >
                                18+
                            </v-btn>
                            <span class="tooltiptext">
                                <span>
                                    <div class="caption">
                                        {{ $t("footer.disclaimer") }} :
                                    </div>
                                    <div
                                        class="caption f12 footer_tooltip_text"
                                    >
                                        {{ $t("footer.disclaimer_text") }}
                                    </div>
                                </span>
                            </span>
                        </div>
                    </div>

                    <!-- <ul class="caption list-style-none">
            <li class="text-sm-left text-md-left text-center">

            </li> -->
                    <!-- <li>
              <div>Disclaimer :</div>
              Please note that Gambling involves

              <v-expand-transition>
                <span v-show="showDisclaimer">
                  a financial risk and could be addictive over time if not
                  practised within limits. Only 18+ people should use the
                  services and should use it responsibly. Players should be
                  aware of any financial risk and govern themselves accordingly.
                </span>
              </v-expand-transition>
              <span
                class="primary--text text-decoration-underline cursor-pointer"
                @click="showDisclaimer = !showDisclaimer"
                >Read {{ `${showDisclaimer ? 'less' : 'more'}` }}</span
              >
            </li> -->
                    <!-- <li class="mb-2">
              &copy; {{ new Date().getFullYear() }} FairPlay. All Rights
              Reserved.
            </li> -->
                    <!-- </ul> -->
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-divider></v-divider>
                </v-col>
                <!-- <v-col
          cols="12"
          sm="12"
          md="4"
          class="d-flex text-center apk-btn caption"
        >
          <v-img
            :src="require('@/assets/images/appstore.png')"
            :lazy-src="require('@/assets/images/appstore.png')"
            :max-width="$breakpoint.smAndDown ? 110 : 124"
            alt="Apk Download"
            contain
            class="androip-apk ma-2"
          >
          </v-img>
          <v-img
            :src="require('@/assets/images/android.png')"
            :lazy-src="require('@/assets/images/android.png')"
            :max-width="$breakpoint.smAndDown ? 120 : 140"
            alt="Apk Download"
            contain
            class="androip-apk ma-2"
          >
          </v-img>
        </v-col> -->
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="text-left caption my-footer hidden-sm-and-down"
                >
                    &copy; {{ new Date().getFullYear() }}
                    <span v-if="domainType && domainType === 'SuperWin'">
                        {{ $t("footer.reserved_Superwin") }}
                    </span>

                    <span v-else>{{ $t("footer.reserved") }}</span>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="4" class="text-center my-footer">
          <social-media class="text-center" size="36" icon-class="mr-2" />
        </v-col> -->
                <v-col
                    cols="12"
                    class="text-left caption my-footer hidden-md-and-up"
                >
                    &copy; {{ new Date().getFullYear() }}
                    <span v-if="domainType && domainType === 'SuperWin'">
                        {{ $t("footer.reserved_Superwin") }}
                    </span>
                    <span v-else>{{ $t("footer.reserved") }}</span>
                </v-col>
                <v-col v-if="setUp !== 'fps'" cols="12" sm="12" md="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col
                    v-show="setUp !== 'fps' && domainType !== 'FairPlay'"
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <div class="container">
                        <div
                            class="row footer-text"
                            justify="center"
                            align="center"
                        >
                            <div class="col-sm-12 text-justify">
                                <p class="footer-text mb-0">
                                    Welcome to Superwin. It's a pleasure to have
                                    you here. When we started this journey, we
                                    had two main goals in mind: to create a
                                    space where you can trust every move you
                                    make, and to ensure you have a great time
                                    doing it.
                                </p>
                                <p>
                                    But what's life without a little fun? Beyond
                                    being a trusted platform, we're also here to
                                    entertain. Our collection of games is
                                    handpicked to bring joy and excitement to
                                    your day. Whether you're a sports
                                    enthusiast, a card game lover, or just
                                    looking for a new adventure, we've got
                                    something for you. Our aim is simple: to
                                    make every moment you spend with us
                                    enjoyable.
                                </p>
                                <strong class="font-weight-bold"
                                    >Sports and Gaming Offerings
                                </strong>
                                <br />
                                <h3 class="text-white mt-4 text-left">
                                    <a
                                        href="https://superwin.co/online-cricket-betting"
                                        class="text-decoration"
                                    >
                                        Cricket
                                    </a>
                                </h3>
                                <p>
                                    Often referred to as a religion in some
                                    parts of the world, cricket is more than
                                    just a sport—it's an emotion. We encapsulate
                                    the spirit of this beloved game, offering
                                    fans an immersive experience. Whether it's
                                    the rapid pace of a T20 match or the
                                    strategic depth of a Test series, cricket
                                    enthusiasts can dive into the game's nuances
                                    and relish every boundary, wicket, and
                                    strategic move.
                                </p>
                                <h3 class="text-white mt-4 text-left">
                                    <a
                                        href="https://superwin.co/soccer-betting"
                                        class="text-decoration"
                                    >
                                        Football
                                    </a>
                                </h3>
                                <p>
                                    Superwin celebrates this universal love for
                                    the 'beautiful game'. From the electrifying
                                    Premier League matches to the fervour of the
                                    World Cup, we cover it all. Experience the
                                    highs of a last-minute goal, the drama of
                                    penalty shootouts, and the strategies of
                                    top-tier club matches.
                                </p>

                                <h3 class="text-white mt-4 text-left">
                                    <a
                                        href="https://superwin.co/worli-matka"
                                        class="text-decoration"
                                    >
                                        Satta Matka - Worli Matka Online
                                    </a>
                                </h3>

                                <p>
                                    A game deeply rooted in history, Satta Matka
                                    has evolved from the streets of Worli,
                                    Mumbai, to the vast realm of the online
                                    world. We proudly bring this traditional
                                    game to our platform, offering a seamless
                                    and modernised digital experience.
                                </p>

                                <h3 class="text-white mt-4 text-left">
                                    <a
                                        href="https://superwin.co/live-cards-games"
                                        class="text-decoration"
                                    >
                                        Live Card Games
                                    </a>
                                </h3>
                                <p>
                                    Live card games are the bridge between
                                    traditional card play and the digital age.
                                    At Superwin, we've brought the real-time
                                    excitement of card games to the virtual
                                    realm. The shuffle of the deck, the strategy
                                    behind every move, and the unpredictability
                                    of your opponent's next play—all come alive
                                    on our platform. Whether you're a poker
                                    enthusiast, a rummy pro, or someone looking
                                    to explore new card games, Superwin promises
                                    an experience that's both engaging and
                                    transparent.
                                </p>
                                <h3 class="text-white mt-4 text-left">
                                    <a
                                        href="https://superwin.co/live-casino"
                                        class="text-decoration"
                                    >
                                        Live Casino
                                    </a>
                                </h3>
                                <p>
                                    The allure of the casino is timeless—the
                                    glitz, the glamour, and the thrill of the
                                    gamble. Superwin's live casino offerings
                                    capture this essence, transporting players
                                    to a world of elegant gaming tables,
                                    professional dealers, and high stakes.
                                    Experience the spin of the roulette wheel,
                                    the roll of the dice, or the challenge of
                                    beating the house in blackjack—all in
                                    real-time. With Superwin's live casino,
                                    every bet is a step into luxury and
                                    excitement.
                                </p>
                                <h3 class="text-white mt-4 text-left">
                                    Commitment to Fairness
                                </h3>
                                <p>
                                    Enter Superwin's patented technology—a
                                    testament to our dedication to ensuring
                                    every user gets a fair shot. While many
                                    platforms might boast about their fairness,
                                    we've gone the extra mile. Our technology
                                    isn't just a feature; it's the backbone of
                                    Superwin. Through meticulous research,
                                    development, and testing, we've crafted a
                                    system that leaves no room for doubt. Every
                                    game, every bet, every move made on our
                                    platform is processed through this
                                    technology, ensuring an unbiased outcome.
                                </p>
                                <p>
                                    Thank you for choosing Superwin. Here's to
                                    countless adventures, epic games, and
                                    moments that will forever be etched in your
                                    memory. Dive in, play fair, and always
                                    remember: At Superwin, every game is a new
                                    story.
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
// import { mapState } from "vuex"
import SocialMedia from "@/components/fairplay/Home/SocialMedia"
export default {
    components: {
        SocialMedia
    },
    data() {
        return {
            setUp: process.env.setUp,
            domainType: process.env.APP_TITLE,
            CDN_IMG_URL: process.env.CDN_IMG_URL,
            liveList: process.env.showLiveList || false,
            path: "",
            footerBlock: false,
            showDisclaimer: false,
            showLiveCardList: false,
            showMatkaList: false,
            showOnlineBettingList: false,
            showEsportsList: false,
            liveCardGames: [
                {
                    name: "3 Cards Judgements",
                    link: "/3-cards-judgement"
                },
                {
                    name: "29 Cards Baccarat",
                    link: "/29-card-baccarat"
                },
                {
                    name: "Andar Bahar",
                    link: "/andar-bahar"
                },
                {
                    name: "Teen Patti T20",
                    link: "/teen-patti-t20"
                },
                {
                    name: "Baccarat",
                    link: "/baccarat"
                },
                {
                    name: "Trio",
                    link: "/trio"
                },
                {
                    name: "Sic Bo",
                    link: "/sic-bo"
                },
                {
                    name: "Casino Meter",
                    link: "/casino-meter"
                },
                {
                    name: "Muflis Teen Patti",
                    link: "/muflis-teen-patti"
                },
                {
                    name: "Roulette",
                    link: "/roulette"
                },
                {
                    name: "Race 20-20",
                    link: "/race-20-20"
                },
                {
                    name: "3 Patti Live",
                    link: "/3-patti-live"
                },
                {
                    name: "7 Up 7 Down",
                    link: "/7-up-7-down"
                },
                {
                    name: "Dragon Tiger",
                    link: "/dragon-tiger"
                },
                {
                    name: "32 Card Casino",
                    link: "/32-card-casino"
                },
                {
                    name: "Hi Lo",
                    link: "/hi-lo"
                },
                {
                    name: "Casino War",
                    link: "/casino-war"
                },
                {
                    name: "Amar Akbar Anthony",
                    link: "/amar-akbar-anthony"
                },
                {
                    name: "Hi Lo",
                    link: "/hi-lo"
                },
                {
                    name: "Online Poker",
                    link: "/poker-online"
                },
                {
                    name: "Race to 17",
                    link: "/race-to-17"
                },
                {
                    name: "Queen Card Game",
                    link: "/queen-card-game"
                },
                {
                    name: "2 Card Teen Patti",
                    link: "/2-card-teen-patti"
                },
                {
                    name: "Teen Patti Test",
                    link: "/teen-patti-test"
                },
                {
                    name: "Teen Patti Open",
                    link: "/teen-patti-open"
                },
                {
                    name: "Bollywood Casino",
                    link: "/bollywood-casino"
                },
                {
                    name: "Poker 20-20",
                    link: "/poker-20-20"
                }
            ],
            listMatkaGame: [
                {
                    name: "Worli Matka",
                    link: "/worli-matka"
                },
                {
                    name: "Kalyan Satta Matka",
                    link: "/kalyan-satta-matka"
                }
            ],
            listSportsGame: [
                {
                    name: "Formula1",
                    link: "/formula-1-betting"
                },
                {
                    name: "Basketball",
                    link: "/basketball-betting"
                },
                {
                    name: "Baseball",
                    link: "/baseball-betting"
                },
                {
                    name: "Dota2",
                    link: "/dota-2-betting"
                },
                {
                    name: "Volleyball",
                    link: "/volleyball-betting"
                },
                {
                    name: "Rugby",
                    link: "/rugby-betting"
                },
                {
                    name: "Boxing",
                    link: "/boxing-betting"
                },
                {
                    name: "Badminton",
                    link: "/badminton-betting"
                },
                {
                    name: "Golf",
                    link: "/golf-betting"
                }
            ],
            listesportsGame: [
                {
                    name: "Virtual sports",
                    link: "/virtual-sports"
                },
                {
                    name: "FIFA esports",
                    link: "/fifa-esports"
                },
                {
                    name: "Counter Strike",
                    link: "/counter-strike"
                }
            ],
            listOne: [
                {
                    name: "footer.online_sports_betting",
                    link: "/online-sports-betting"
                },
                // {
                //     name: "footer.card_game",
                //     link: "/live-card-games"
                // },
                {
                    name: "footer.cricket_betting",
                    link: "/online-cricket-betting"
                },
                {
                    name: "footer.ipl_betting",
                    link: "/ipl-betting"
                },
                {
                    name: "footer.football_betting",
                    link: "/soccer-betting"
                },
                {
                    name: "footer.tennis_betting",
                    link: "/tennis-betting"
                },
                // {
                //   name: 'Premium Sportsbook Betting',
                //   link: '/premium-sportsbook'
                // },
                // {
                //     name: "footer.live_casino_betting",
                //     link: "/live-casino"
                // },
                {
                    name:
                        process.env.APP_TITLE === "SuperWin"
                            ? "footer.online_bettting_app_Superwin"
                            : "footer.online_bettting_app",
                    link: "/online-betting-app/"
                }
            ],
            listOneForSuperwin: [
                {
                    name: "footer.online_sports_betting",
                    link: "/online-sports-betting/"
                },
                {
                    name: "footer.cricket_betting",
                    link: "/online-cricket-betting"
                },
                {
                    name: "IPL Betting",
                    link: "/ipl-betting"
                },
                {
                    name: "footer.football_betting",
                    link: "/soccer-betting"
                },
                {
                    name: "footer.tennis_betting",
                    link: "/tennis-betting"
                },
                {
                    name: "footer.live_casino_betting",
                    link: "/live-casino"
                },
                {
                    name: "Satta Matka",
                    link: "/satta-matka",
                    disable: "!spw"
                },
                {
                    name: "Online Betting",
                    link: "/online-betting",
                    disable: "!spw"
                },
                {
                    name: "Esports",
                    link: "/esports",
                    disable: "!spw"
                },
                {
                    name: "Live Cards",
                    link: "/live-cards-games",
                    disable: "!spw"
                },
                {
                    name:
                        process.env.APP_TITLE === "SuperWin"
                            ? "footer.online_bettting_app_Superwin"
                            : "footer.online_bettting_app",
                    link: "/download-the-app"
                }
            ],
            listTwo: [
                // {
                //   name: 'Betting Websites',
                //   link: '/platforms'
                // },
                {
                    name: "footer.about_us",
                    link: "/about-us"
                },
                {
                    name: "footer.rules",
                    link: "/rules-regulations"
                },
                {
                    name: "footer.privacy_policy",
                    link: "/privacy-policy"
                },
                {
                    name: "footer.sitemap",
                    link: "/sitemap"
                },
                {
                    name: "footer.responsible_gambling",
                    link: "/responsible-gambling"
                },
                {
                    name: "footer.terms_condition",
                    link: "/termsandconditions"
                },
                {
                    name: "AML Policies",
                    link: "https://bestfairplay.com/aml-policies"
                }
                // {
                //   name: 'Cricket Betting & Tips',
                //   link: '/markets/sportsbook/Cricket'
                // },
                // {
                //   name: 'Football Betting & Tips',
                //   link: '/markets/sportsbook/Football'
                // },
                // {
                //   name: 'Tennis Betting & Tips',
                //   link: '/markets/sportsbook/Tennis'
                // },
                // {
                //   name: 'Horce Racing Betting & Tips',
                //   link: '/markets/sportsbook/Horse-Racing'
                // },
                // {
                //   name: 'Gameshows',
                //   link: '/markets/live-casino/Game-Shows'
                // },
                // {
                //   name: 'Responsible Gambling',
                //   link: '/responsible-gambling'
                // }
            ],
            listThree: [
                // {
                //   name: 'Roulette Game Online',
                //   link: '/markets/live-casino/Roulette'
                // },
                // {
                //   name: 'Baccarat Online',
                //   link: '/markets/live-casino/Baccarat'
                // },
                // {
                //   name: 'Poker Online',
                //   link: '/markets/live-casino/Poker'
                // },
                // {
                //   name: 'Blackjack Online',
                //   link: '/markets/live-casino/Blackjack'
                // },
                // {
                //   name: 'Blog',
                //   link: '/blog'
                // },
                {
                    name:
                        process.env.APP_TITLE === "SuperWin"
                            ? "Superwin news"
                            : "footer.news",

                    link:
                        process.env.APP_TITLE === "SuperWin"
                            ? "https://superwinnews.com/"
                            : "https://fairplay-news.co/",
                    hide: false
                },
                {
                    name: "footer.premium_sportbook_betting",
                    link: "/premium-sportsbook",
                    hide: false
                },
                {
                    name: "footer.affiliate",
                    link: "/affiliate-partner",
                    disable: "fps",
                    hide: false
                }

                // {
                //   name: 'footer.live_card_betting',
                //   link: '/live-cards'
                // },
                // {
                //   name: 'footer.oneline_slot_betting',
                //   link: '/casino-slots'
                // },
                // {
                //   name: 'footer.know_more',
                //   link: '/sports/online-cricket-betting'
                // }
            ],
            listFour: [
                // {
                //   name: 'privacy policy',
                //   link: '/privacy-policy'
                // },
                {
                    name: "footer.faq",
                    link: "/faqs"
                },
                {
                    name: "footer.tutorials",
                    link: "/tutorials"
                },
                {
                    name: "footer.market",
                    link: "/markets/sportsbook/Cricket"
                },
                {
                    name: "footer.loyalty",
                    link: "/loyalty"
                },
                {
                    name: "footer.contact_us",
                    link: "/contact-us"
                }
            ],
            listSattaGame: [
                {
                    name: "Worli Matka",
                    link: "/worli-matka"
                },
                {
                    name: "Kalyan Satta Matka",
                    link: "/kalyan-satta-matka"
                }
            ]
        }
    },

    computed: {
        // ...mapState({
        //     getWhatsappData: (state) => state.user.whatsappData
        // }),
        version() {
            return this.$store.state.profile.appversion
        }
    },

    watch: {
        $route(to, from) {
            this.path = this.$route.path
            this.abc(this.path)
        }
    },
    mounted() {
        this.abc(this.$nuxt.context.route.path)
        if (
            this.domainType === "SuperWin" &&
            this.listFour &&
            this.listFour.length
        ) {
            this.listFour = this.listFour.filter((item) => {
                return (
                    item.name !== "footer.market" &&
                    item.name !== "footer.tutorials"
                )
            })
        }
        if (
            this.domainType === "FairPlay" &&
            this.listFour &&
            this.listFour.length
        ) {
            this.listFour = this.listFour.filter((item) => {
                return item.name !== "footer.tutorials"
            })
        }
        if (
            this.domainType === "SuperWin" &&
            this.listThree &&
            this.listThree.length
        ) {
            this.listThree = this.listThree.filter((item) => {
                return item.name !== "Superwin news"
            })
        }
    },
    async created() {
        await this.$store.dispatch("user/getconfigs")
    },
    methods: {
        abc(path) {
            if (path === "/") {
                this.footerBlock = true
            } else {
                this.footerBlock = false
            }
        },
        handleShowHideLiveCards(item) {
            if (item === "Live Cards") {
                this.showLiveCardList = !this.showLiveCardList
            } else if (item === "Satta Matka") {
                this.showMatkaList = !this.showMatkaList
            } else if (item === "Online Betting") {
                this.showOnlineBettingList = !this.showOnlineBettingList
            } else if (item === "Esports") {
                this.showEsportsList = !this.showEsportsList
            }
        },
        getListOne() {
            if (this.domainType === "SuperWin") {
                return this.listOneForSuperwin
            } else {
                return this.listOneForSuperwin
            }
        }
    }
}
</script>
<style lang="scss">
.main-foot {
    .margin-17 {
        margin-bottom: 85px;
    }
    .caption-foot {
        font-family: "Roboto", sans-serif;
        font-display: swap;
        font-weight: 400;
        letter-spacing: 0.0333333333em;
        line-height: 1.25rem;
        font-size: 11px;
    }
    @media only screen and (max-width: 320px) {
        .caption-foot {
            font-size: 0.6rem;
        }
    }
    // margin-top: 60px;
    .gaming-image {
        display: grid;
        place-content: center;
    }
    .androip-apk:hover {
        filter: brightness(170%);
        cursor: pointer;
    }
    // .apk-btn {
    //   place-content: center;
    // }
    // .my-footer {
    //   display: grid;
    //   place-content: center;
    // }
    .col-md-2 ul li a:hover {
        color: var(--v-normalThemeColor-base) !important;
    }
    .col-md-1 ul li a:hover {
        color: var(--v-normalThemeColor-base) !important;
    }
}
.list-style-none {
    list-style: none;
}
.footer-icon {
    .v-btn--icon.v-size--default {
        width: 23px !important;
        height: 23px !important;
    }
    .v-btn__content {
        justify-content: start !important;
    }
}

.list-display {
    display: block;
}
.list-hide {
    display: none;
}
.live-cards-button {
    margin-left: 10px;
}
.live-cards-list {
    width: 150px !important;
    list-style: none;
}
.footer_tooltip {
    position: relative;
    right: 10px;
    display: inline-block;
    z-index: 4;
}

.footer_tooltip .tooltiptext {
    visibility: hidden;
    width: 240px;
    background-color: var(--v-primary-base) !important;
    border-color: var(--v-primary-base) !important;
    background: transparent;
    color: #fff;
    border-radius: 6px;
    padding: 5px 12px 5px;
    position: absolute;
    z-index: 4;
    bottom: 125%;
    left: -9rem;
}

.footer_tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}
.footer_tooltip_text {
    line-height: 1.5 !important;
}
.footer-text {
    font-size: 0.875rem;
    line-height: 1.8;
    color: white;
}
.expansion_arrow {
    position: absolute;
    top: 22px;
    right: 3px;
}
</style>
